<template>
  <div>
    <Worktemp
      data-aos="fade-down"
      :workTitle="work.tittle"
      :workPara="work.para"
      :companyName="work.company"
      :yearName="work.year"
      :projectType="work.project"
    ></Worktemp>
    <WorkcoverImg :coverimg="work.coverimg" data-aos="fade-up" />
    <WorkTwoImg :TwoImgleft="work.TwoImgleft" :TwoImgRight="work.TwoImgRight" />
    <WorkThreeImg
      :ThreeImgleft="work.ThreeImgleft"
      :ThreeImgRight="work.ThreeImgRight"
    />
    <WorkcoverImg :coverimg="work.coverimg2" />
    <hire />
  </div>
</template>
<script>
import Worktemp from "@/components/Worktemp.vue";
import WorkcoverImg from "@/components/WorkcoverImg.vue";
import WorkTwoImg from "@/components/WorkTwoImg.vue";
import WorkThreeImg from "@/components/WorkThreeImg.vue";
export default {
  components: {
    Worktemp,
    WorkcoverImg,
    WorkTwoImg,
    WorkThreeImg,
  },
  data() {
    return {
      work: {
        tittle: "Dhanam",
        para: "Dhanam was an app design project that came to me during my employment ship at Cobold. From ideation, user journey, design, & prototyping, we aced it all. It came out so well in the duo language.",
        company: "Dhanam",
        year: "2021",
        project: "Application Design",
        coverimg: "/img/gallery/ui/dhanam/cover.jpg",
        TwoImgleft: "/img/gallery/ui/dhanam/twoleft.svg",
        TwoImgRight: "/img/gallery/ui/dhanam/tworight.jpg",
        ThreeImgleft: "/img/gallery/ui/dhanam/threeleft.svg",
        ThreeImgRight: "/img/gallery/ui/dhanam/threeright.svg",
      },
    };
  },
};
</script>
